import React, { useState, useEffect } from "react";
import { accountDeleteLogin } from "../../utils/routes";
import parse from "html-react-parser";
// import contactbg from "../assets/img/Contact.png";
// import emailicon from "../assets/img/email.svg";
// import phone from "../assets/img/telephone.svg";
// import map from "../assets/img/image.svg";
// import queryicon from "../assets/img/query icon.svg";
// import subjecticon from "../assets/img/subject icon.svg";
import { contactUs, contactQuery } from "../../utils/routes";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { Rings } from "react-loader-spinner";
import Formimg from "../../assets/img/contactform illustration.svg";
import closei from "../../assets/img/Overlay close icon.svg";
import user from "../../assets/img/user icon.svg";
import { IoIosLock } from "react-icons/io";
import { Spinner } from "react-bootstrap";

function Login({ setAuthentication, setGetLoggedInUser }) {
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm({
    mode: "onTouched",
  });

  const onSubmit = (data) => {
    let num = "";
    if (data.username.startsWith("0")) {
      let strippedNumber = data.username.replace(/^0+/, "");
      // Add +92
      // number = data.username.substring(1);
      num = `+92${strippedNumber}`;
    }

    // setAuthentication(true);

    const getUserRequestDTO = {
      method: "POST",

      headers: {
        "Content-Type": "application/json",
        userName: num ? num : data.username,
        password: btoa(data.password),
        channelId: "mobile",
      },
    };
    fetch(accountDeleteLogin, getUserRequestDTO)
      .then((res) => res.json())
      .then((result) => {
        if (result.statusCode == 0) {
          setAuthentication(true);
          setGetLoggedInUser({ accountId: result.result.accountId, ...data });
          toast.success(result.result.description);
        } else {
          toast.error(result.statusDescription);
        }
      });
  };
  return (
    <>
      {isSubmitting ? (
        <div className={"overlay"}>
          <span id="loading">
            <Rings color="#91298c" height={160} width={160} />
          </span>
        </div>
      ) : null}

      <form onSubmit={handleSubmit(onSubmit)} className="form-wrapper">
        <div className="form-group">
          <label className="inputfield">Username</label>
          <div className="form-icon">
            <img src={user} />
          </div>
          <input
            maxLength={13}
            className="form-control"
            type="text"
            placeholder="Enter your username"
            {...register("username", {
              required: {
                value: true,
                message: "Username is required",
              },
            })}
          />
          <small className="form-feedback position-absolute">
            {errors ? errors["username"]?.message : null}
          </small>
        </div>
        <div className="form-group">
          <label className="inputfield">Password</label>
          <div className="form-icon">
            <IoIosLock color="#785d78" size={20} />
          </div>
          <input
            className="form-control"
            name="password"
            type="password"
            placeholder="********"
            {...register("password", {
              required: {
                value: true,
                message: "Password is required",
              },
            })}
          />

          <small className="form-feedback position-absolute">
            {errors ? errors["password"]?.message : null}
          </small>
        </div>

        <div className="col-lg-12 d-flex justify-content-end">
          {" "}
          <button
            className="btn btn-contect"
            type="submit"
            disabled={isSubmitting}
          >
            {isSubmitting ? (
              <Spinner animation="border" role="status">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
            ) : (
              "Login"
            )}
          </button>
        </div>
      </form>
    </>
  );
}
export default Login;
